import axios from "axios";

export const createDocketAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_DOCKET_URL}/docket/createDocket`,
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};
